import { useState } from "react";
import "./navigationBar.css";
import {useNavigate} from 'react-router-dom';

function NavigationBar({
  text,
  profile,
  bool,
  setCurrent,
  login,
  admin,
  style,
  handleLogOut,
}) {
  const [visible, setVisible] = useState(false);
  const Navigate = useNavigate();
  // console.log(admin);

  const handleClicks = () => {
    // console.log('hello')
    if (!bool) {
      setVisible(!visible);
    } else {
      setVisible(false);
    }
    if (admin) {
      // console.log('hi');
      handleLogOut(admin);
    }
  };

  const handleClicksoverlay = () => {
    setVisible(false);
  };
  return (
    <nav>
      <div
        id="logo"
        onClick={() => {
          login ? setCurrent(0) : (login = false);
        }}
      ></div>
      <div id="center">
        <div>
          {text.split("\n").map((line, index) => (
            <div className="text" key={index}>
              {line}
              <br />
            </div>
          ))}
        </div>
      </div>
      {profile && <div id="person-icon" onClick={handleClicks}></div>}
      {visible && !admin && (
        <div id="overlay1" onClick={handleClicksoverlay}>
          <div id="list" style={style}>
            <div className="item" onClick={() => Navigate("/changePassword")}>
              Change Password
            </div>
            <div className="item" onClick={()=>handleLogOut(admin)}>
              Logout
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default NavigationBar;
